import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ListItem } from '../models/lists.model';
import { GenericListService } from './lists.service';

export enum ARCommonListType {
  FERTILIZER_TYPES,
  CONSOLE_MODULATION_TYPES,
  CONSOLE_FORMAT_TYPES,
  CONSOLE_VERSIONS,
  CONSOLE_TYPES,
}

// TODO refactor lists.service pour ne pas dupliquer le code ?
@Injectable({ providedIn: 'root' })
export class ARCommonListsService extends GenericListService<ARCommonListType> {
  constructor(http: HttpClient) {
    super(http);
    this.listsUrl = '/tools/agrorendement/common/lists';
  }

  handleResponse(response: any) {
    const data = response.data;
    const converted = new Map<ARCommonListType, ListItem[]>();
    for (const d in data) {
      const listType: ARCommonListType = <any>ARCommonListType[<any>d];
      if (
        listType !== ARCommonListType.CONSOLE_FORMAT_TYPES &&
        listType !== ARCommonListType.CONSOLE_TYPES &&
        listType !== ARCommonListType.CONSOLE_VERSIONS
      ) {
        // pas de i18n pour les consoles et les formats
        const value = data[d];
        const typeData = value.map(this.extractI18n);
        converted.set(listType, typeData);
        this.cache.set(listType, typeData);
      } else {
        converted.set(listType, data[d]);
        this.cache.set(listType, data[d]);
      }
    }
    return converted;
  }
}
